import TranslationsTable from 'components/Translations/TranslationsTable';
import useActions from 'hooks/useActions';
import { useEffect } from 'react';

const { connect } = require('react-redux');

function mapStateToProps(state) {
    return {
        article: state.CsArticles.selectedArticle,
        translations: state.CsArticles.translations,
        page: state.CsArticles.translations_page,
        per_page: state.CsArticles.translations_per_page,
        total: state.CsArticles.translations_total,
        total_pages: state.CsArticles.translations_total_pages,
        isLoading: state.CsArticles.translations_is_loading,
        selectedTranslation: state.CsArticles.selectedTranslation,
    };
}

const ArticleTranslations = connect(mapStateToProps)(function (props) {
    const {
        article,
        translations,
        page,
        per_page,
        total,
        total_pages,
        isLoading,
        selectedTranslation,
    } = props;

    const {
        CS_FETCH_ARTICLE_TRANSLATIONS_REQUEST,
        CS_POST_ARTICLE_TRANSLATION_REQUEST,
        CS_UPDATE_ARTICLE_TRANSLATION_REQUEST,
        CS_DELETE_ARTICLE_TRANSLATION_REQUEST,
        CS_SELECT_ARTICLE_TRANSLATION,
    } = useActions();

    function onNext() {
        CS_FETCH_ARTICLE_TRANSLATIONS_REQUEST({
            articleId: article?.id,
            page: page + 1,
            per_page,
        });
    }

    function onPrev() {
        CS_FETCH_ARTICLE_TRANSLATIONS_REQUEST({
            articleId: article?.id,
            page: page - 1,
            per_page,
        });
    }

    function onPageSelected(selectedPage) {
        CS_FETCH_ARTICLE_TRANSLATIONS_REQUEST({
            articleId: article?.id,
            page: selectedPage,
            per_page,
        });
    }

    function onPerPageSelected({ perPage }) {
        CS_FETCH_ARTICLE_TRANSLATIONS_REQUEST({
            articleId: article?.id,
            per_page: perPage,
        });
    }

    function onDelete(translation) {
        CS_DELETE_ARTICLE_TRANSLATION_REQUEST({
            articleId: article?.id,
            page,
            per_page,
            translationId: translation.id,
        });
    }

    function onUpdate(translation) {
        CS_UPDATE_ARTICLE_TRANSLATION_REQUEST(translation);
    }

    function onCreate(translation) {
        CS_POST_ARTICLE_TRANSLATION_REQUEST({
            resourceId: article.id,
            translation,
        });
    }

    useEffect(() => {
        CS_FETCH_ARTICLE_TRANSLATIONS_REQUEST({
            articleId: article?.id,
        });
        return () => {
            CS_SELECT_ARTICLE_TRANSLATION(null);
        };
        // eslint-disable-next-line
    }, []);

    return (
        <TranslationsTable
            page={page}
            perPage={per_page}
            onNext={onNext}
            onPrev={onPrev}
            onPageSelected={onPageSelected}
            onPerPageSelected={onPerPageSelected}
            isLoading={isLoading}
            total={total}
            totalPages={total_pages}
            onDelete={onDelete}
            translations={translations}
            onSelect={CS_SELECT_ARTICLE_TRANSLATION}
            onCreate={onCreate}
            onUpdate={onUpdate}
            selectedTranslation={selectedTranslation}
        />
    );
});

export default ArticleTranslations;
